// extracted by mini-css-extract-plugin
export default {"classWrapper":"TaskBlock_classWrapper__sP2bx"};